import React, { useState } from "react";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { ImageModal, VideoModal } from "../../../common/Modals";
import { AppTableBody } from "../../../../Libraries";
import Icon from "../../../../assets/Icon";
import styles from "./../OrderDetail/styles.module.css";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const ListItem = ({ key, I18n, item }) => {
  const {
    return_evidence_url,
    product_image,
    amount_total,
    product_name,
    product_id,
    quantity,
  } = item || {};

  const [imageModal, setImageModal] = useState(false);
  const [videoModal, setVideoModal] = useState(false);

  /**
   * Receive toggle to toggle image modal based in toggle value
   * @returns set setImageModal to treu or false
  */
  const toggleImageModal = (toggle = false) => setImageModal(toggle);

  /**
   * Receive toggle to toggle video modal based in toggle value
   * @returns set setVideoModal to treu or false
  */
  const toggleVideoModal = (toggle = false) => setVideoModal(toggle);

  return (
    <AppTableBody className={"fiveColumn"} key={key}>
      <div className="BoxWidth justifyStart productNameBox">
        <p className={styles.productImageBox}>
          {product_image ? (
            <img src={product_image} style={{ resize: "cover" }} />
          ) : (
            <Icon
              data={{
                viewBox: "0 0 51 51",
                name: "cameraIcon",
                height: "18px",
                width: "18px",
                fill: "#000"
              }}
            />
          )}
        </p>
        <p
          className="orderProductName fontSize14 truncateTwoLine darkGrayColor"
          title={product_name}
        >
          {product_name}
        </p>
      </div>
      <div className="BoxWidth justifyCenter">
        <p className="fontSize14 truncateOneLine darkGrayColor">{product_id}</p>
      </div>

      <div className="BoxWidth justifyCenter">
        <p className="fontSize14 truncateOneLine darkGrayColor">{quantity}</p>
      </div>
      <div className="BoxWidth justifyCenter">
        <p className={return_evidence_url ? styles.productImageBox : ""}>
          {return_evidence_url ? (
            return_evidence_url.includes(".mp4") ? (
              <video
                width="320"
                height="240"
                src={return_evidence_url}
                onClick={() => {
                  triggerLogEvent(analytics, "sc_order_return_item_click", { product_name, evidence_type: "video" });
                  toggleVideoModal(true);
                }}
              >
                Your browser does not support the video.
              </video>
            ) : (
              <img
                src={return_evidence_url}
                style={{ resize: "cover" }}
                onClick={() => {
                  triggerLogEvent(analytics, "sc_order_return_item_click", { product_name, evidence_type: "image" });
                  toggleImageModal(true);
                }}
              />
            )
          ) : (
            "-"
          )}
        </p>
      </div>

      <div className="BoxWidth justifyCenter">
        <p className="fontSize14 truncateOneLine darkGrayColor">
          Rs. {formatNum(amount_total)}
        </p>
      </div>

      <ImageModal
        header={{ title: "evidence_image" }}
        body={{
          image: return_evidence_url,
          toggle: imageModal,
          toggleImageModal,
        }}
        footer={[{
          data: {
            className: "ubPrimaryButton",
            title: I18n.close,
            onClick: () => toggleImageModal(),
            id: `image_cancel`,
          },
        }]}
      />

      <VideoModal
        header={{ title: I18n.evidence_video }}
        body={{
          video: return_evidence_url,
          toggle: videoModal,
          toggleVideoModal,
        }}
        footer={[]}
      />
    </AppTableBody>
  );
};

export default ListItem;
